import { get } from './utils';

const getPoints = () => get('/point/details');

export const points = {
  getPoints
};
